import { IAppState } from '../../common/state';
import { IGenplan } from '../../types/newbuildingHeader';

export function getGenplan({ newbuildingInformation }: IAppState): IGenplan | null {
  return newbuildingInformation?.genplan || null;
}
